// extracted by mini-css-extract-plugin
module.exports = {"result":"grid_result__o3pUc"};